import { ApplicationState } from '../../../../store/types';
import { getUsersRoot } from '../../store/selectors';
import { BasicUserInfo, ClientUser, FeaturePermissionDB, NewUser } from './types';

export const getModalOpen = (state: ApplicationState): boolean => getUsersRoot(state).modalOpen;

export const getNewUser = (state: ApplicationState): NewUser => getUsersRoot(state).user;

export const getUsernameUnavailable = (state: ApplicationState): boolean => getUsersRoot(state).usernameUnavailable;

export const getCheckingUsername = (state: ApplicationState): boolean => getUsersRoot(state).checkingUsername;

export const getEmailValid = (state: ApplicationState): boolean => getUsersRoot(state).emailValid;

export const getAllUsers = (state: ApplicationState): ClientUser[] => getUsersRoot(state).allUsers;

export const getAvailableFeaturePermissions = (state: ApplicationState): FeaturePermissionDB[] => getUsersRoot(state).availableFeaturePermissions;

export const getConfirmDeleteUser = (state: ApplicationState): ClientUser | null => getUsersRoot(state).confirmDeleteUser;

export const getIsDeleting = (state: ApplicationState): boolean => getUsersRoot(state).deletingUser;

export const getIsFetchingUsers = (state: ApplicationState): boolean => getUsersRoot(state).fetchingUsers;

export const getAllBasicUsers = (state: ApplicationState): BasicUserInfo[] => getUsersRoot(state).basicUserInfo;
